import React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { antwoordOp, zetAntwoord } from "../../../lib/enquete";
import { setAddFields } from "../../../store/slice/feedback.slice";
import { vertaal as jmVertaal } from "../../../lib/woorden";
import { hoekMaat } from "../../../lib/hoek";

// "Zou je ons aanraden?": elf knoppen, 0 tot en met 10 (Martijn 14-10-2026). 0 is ook een antwoord.
export const NpsKeuze = ({ vraag, Css }) => {
  const dispatch = useDispatch();
  const { addFields } = useSelector((s) => s.feedback);
  const gekozen = antwoordOp(addFields, vraag?.idenquetefield)?.rating;
  const accent = Css?.StarClr || "#f37120";

  return (
    <Box>
      <Box
        role="radiogroup"
        aria-label={vraag?.name}
        sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(6, 1fr)", sm: "repeat(11, 1fr)" }, gap: 1, mt: 2 }}
      >
        {Array.from({ length: 11 }, (_, cijfer) => {
          const aan = gekozen === cijfer;
          return (
            <ButtonBase
              key={cijfer}
              role="radio"
              aria-checked={aan}
              onClick={() => dispatch(setAddFields(zetAntwoord(addFields, vraag?.idenquetefield, { rating: cijfer })))}
              sx={{
                height: 44,
                borderRadius: hoekMaat(10),
                border: `1px solid ${aan ? accent : Css?.QuestionCardBorderClr || "rgba(0,0,0,0.15)"}`,
                backgroundColor: aan ? accent : "#fff",
                color: aan ? "#fff" : Css?.QuestionClr || "#111827",
                fontWeight: 600,
                fontSize: "15px",
              }}
            >
              {cijfer}
            </ButtonBase>
          );
        })}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
        <Typography sx={{ fontSize: "12px", color: Css?.feedbackInfoClr || "#6b7280" }}>{jmVertaal("Zeker niet")}</Typography>
        <Typography sx={{ fontSize: "12px", color: Css?.feedbackInfoClr || "#6b7280" }}>{jmVertaal("Zeker wel")}</Typography>
      </Box>
    </Box>
  );
};
